<template>
    <router-view
        @busy="handleBusy"
        @active-channel-change="handleActiveChannelChange"
        :active-channel="activeChannel"
    ></router-view>
</template>

<script>
import { getNextpaxChannels, NEXTPAX_CHANNEL_BOO142 } from '../../../constants';

const localStorageActiveNextpaxChannelKey = 'partnerActiveNextpaxChannel';

export default {
    name: 'PartnerNextpax',
    data() {
        return {
            activeChannel: this.getActiveChannel(),
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (to.path === '/app/partner/nextpax/') {
            return;
        }
        next();
    },
    mounted() {
        if (this.$route.path === '/app/partner/nextpax/') {
            if (this.activeChannel) {
                this.$router.replace(`/app/partner/nextpax/${this.activeChannel.toLowerCase()}/`);
            } else {
                this.boo142Redirect();
            }
        }
    },
    methods: {
        handleBusy(busy) {
            this.$parent.$emit('busy', busy);
        },
        handleActiveChannelChange(channel) {
            this.$router.push(`/app/partner/nextpax/${channel.toLowerCase()}/`);
            localStorage.setItem(localStorageActiveNextpaxChannelKey, channel);
            this.activeChannel = channel;
        },
        boo142Redirect() {
            this.$router.push(`/app/partner/nextpax/${NEXTPAX_CHANNEL_BOO142.toLowerCase()}/`);
            this.setBoo142ActiveChannel();
        },
        setBoo142ActiveChannel() {
            this.activeChannel = NEXTPAX_CHANNEL_BOO142;
            localStorage.setItem(localStorageActiveNextpaxChannelKey, NEXTPAX_CHANNEL_BOO142);
        },
        getActiveChannel() {
            const channels = getNextpaxChannels();
            for (let channel of channels) {
                if (this.$router.currentRoute.value.path.includes(channel.toLowerCase())) {
                    localStorage.setItem(localStorageActiveNextpaxChannelKey, channel);
                    return channel;
                }
            }
            const current = localStorage.getItem(localStorageActiveNextpaxChannelKey);
            if (channels.includes(current)) {
                return current;
            }
            return null;
        },
    },
};
</script>
